import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import UserMenu from '../UserMenu/UserMenu';
import { logoutUser } from '../../auth/actions';

import { headerThemes } from '../../utils/constants';

const UserData = ({ theme }) => {
  const { config: { securitizeIdUrl, hasFAQs } } = useSelector(({ issuerConfiguration }) => issuerConfiguration);
  const dispatch = useDispatch();

  const options = [
    {
      icon: 'icon-profile',
      i18nKey: 'Texts.go-to-securitize-id',
      isExternalUrl: true,
      path: securitizeIdUrl,
    },
    hasFAQs && {
      path: '/faq',
      icon: 'icon-info',
      i18nKey: 'Texts.faq',
    },
    {
      icon: 'icon-log-out',
      onClick: () => {
        dispatch(
          logoutUser(),
        );
      },
      path: '/login',
      i18nKey: 'Texts.log-out',
      isExternalUrl: false,
    },
  ].filter(Boolean);
  return (
    <div>
      <UserMenu
        hideUserData={false}
        menuItems={options}
        theme={theme}
      />
    </div>

  );
};

UserData.defaultProps = {
  theme: headerThemes.LIGHT,
};

UserData.propTypes = {
  theme: PropTypes.oneOf(Object.keys(headerThemes)),
};

export default UserData;
